const Types = {
  TYPE_ADDING: 'type/adding',
  TYPE_UPDATE: 'type/update',
  TYPE_STATUS_UPDATE: 'type/status_update',
};

export default Types;
